
import React, { useState, useEffect, useRef } from 'react'
import { Button } from 'react-bootstrap';
import Modal from 'react-bootstrap/Modal'
import Swal from 'sweetalert2';

function ModalSeparators({ separators, formatJsonToAddShoppingCart }) {
    const [show, setShow] = useState(false);


    const selectSeparator = (separator) => {

        const swalWithBootstrapButtons = Swal.mixin({
            customClass: {
                confirmButton: 'btn btn-success',
                cancelButton: 'btn btn-danger'
            },
            buttonsStyling: false
        })

        swalWithBootstrapButtons.fire({
            title: 'Separador de productos',
            text: '¿Estas seguro de agregar este separador?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Si!',
            cancelButtonText: 'No!',
            reverseButtons: true
        }).then((result) => {
            if (result.isConfirmed) {
                swalWithBootstrapButtons.fire(
                    'Separador agregador',
                    '',
                    'success'
                )


                formatJsonToAddShoppingCart(separator)
                setShow(false)
            } else if (
                /* Read more about handling dismissals below */
                result.dismiss === Swal.DismissReason.cancel
            ) {
                swalWithBootstrapButtons.fire(
                    'Cancelaste el separador',
                    '',
                    'info'
                )
            }
        })
    }





    return (
        <>

            <button className='btn-pre-order px-2 py-1 btn btn-outline-light-secondary rounded-3 btn-sm'
                onClick={() => setShow(true)}>
                <i class="uil uil-align-center-v"></i>
                <small className='fw-bold buttons-label d-none d-lg-inline ' >
                    Separador
                </small>
            </button>


            <Modal
                show={show}
                size="md"
                centered
                closeButton
                onHide={() => (setShow(false))}
            >
                <Modal.Body >
                    <div className="d-flex justify-content-center border-bottom-0">
                        <h1 className="modal-title fw-bold fs-5">

                            <i class="uil uil-align-center-v"></i>
                            Separador de productos
                        </h1>
                    </div>


                    <div className='flex-container'>
                        {separators.map((separator, index) => (
                            <>

                                <div className="btn btn-outline-primary rounded-3 border m-1" onClick={() => (selectSeparator(separator))}>
                                    <i class="uil uil-arrow-from-top"></i> {separator.name}
                                </div>
                            </>
                        ))}

                    </div>

                </Modal.Body>
            </Modal>


        </>
    )
}

export default ModalSeparators